export default __webpack_public_path__ + "static/media/walletIDSVG.5ad482de.svg";